import Vue from 'vue';
import App from './App.vue';
import router from './router/routes';
import axios from 'axios';
import './plugins/axios';
import store from './store/store';
import vuetify from './plugins/vuetify';
import '@fortawesome/fontawesome-free/css/all.css';
import './plugins/clipboard';
import './plugins/global';
import './plugins/prism';
import './plugins/quill-editor';
import './plugins/vee-validate';
import './plugins/webfont';
import './plugins/youtube';
import './plugins/amplitudejs';

const vm = new Vue({
    // eslint-disable-line
    axios: axios,
    router: router,
    store: store,
    vuetify: vuetify,
    render: h => h(App)
});

setTimeout(() => {
    vm.$mount('#app');
}, 3000);
